import defaultImport from '../import/initialState';

const { inbox } = window;
const color = inbox.fields.color.required;
const flag = inbox.fields.flag.required;
const rating = inbox.fields.rating.required;

export default {
  ...defaultImport,
  addedCustomFields: (inbox?.fields?.customFields || []).filter(({ show, required }) => show && !required),
  requiredFields: {
    comments: inbox.fields.comment.required,
    titleAndDescription: inbox.fields.titleAndDescription.required,
    color,
    flag,
    rating,
    assetMarks: color || flag || rating,
    customFields: (inbox.fields?.customFields || []).reduce((result, cf) => {
      if (cf.required) return [...result, cf.title];
      return result;
    }, []),
  },
  promotionalBannerDisabled: inbox.brandingSettings?.promotionalBannerDisabled,
  theme: inbox?.theme || 'dark',
};
